<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import echarts from 'echarts'
require('echarts/theme/macarons') // echarts theme

export default {
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    }
  },
  data () {
    return {
      chart: null,
      seriesData: null
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart () {
      this.chart = echarts.init(this.$el, 'macarons')

      this.chart.setOption({
        // backgroundColor: '#2c343c',

        title: {
          text: '',
          left: 'center',
          top: 20,
          textStyle: {
            color: '#ccc'
          }
        },

        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },

        // visualMap: {
        //   show: false,
        //   min: 0,
        //   max: 200,
        //   inRange: {
        //     colorLightness: [0, 1]
        //   }
        // },
        //设置饼状图每个颜色块的颜色
        series: this.seriesData
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/selfTest/PieChart.vue